import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Row, Card, Form } from '@themesberg/react-bootstrap'
import { Context } from '../index'
import { useCookies } from 'react-cookie';
import { getSummary } from '../controller';

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['wvivu'])

  const [summary, setSummary] = useState({
    count: 0,
    value: 0
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const filterPressCount = useRef(state.filterPressCount)

  const getSummaryFunc = useCallback(async () => {
    setLoading(true)
    const filterObj = state.filter.method === 'BY_CONDITION' ? {
      from: state.filter.from,
      to: state.filter.to,
      identify: state.filter.identify,
      routeId: state.filter.routeId,
      status: state.filter.status,
    } : state.filter.method === 'BY_ID' ? {
      id: state.filter.id,
    } : {
      cartId: state.filter.cartId,
    }
    const response = await getSummary(cookies.wvivu, filterObj)
    if (response) {
      setSummary(response)
      setError(false)
    } else {
      setError(true)
    }
    setLoading(false)
  }, [cookies.wvivu, state.filter.from, state.filter.to, state.filter.identify, state.filter.routeId, state.filter.status, state.filter.id, state.filter.cartId, state.filter.method])

  const listSumary = useMemo(() => {
    return (
      <Row>
        <Col md={6} sm={6}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Số lượng"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.count) || ""}</Form.Label>
          </Row>
        </Col>
        <Col md={6} sm={6}>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{"Tổng tiền"}</Form.Label>
          </Row>
          <Row md={12} className='text-center align-self-center'>
            <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(summary.value) || ""}</Form.Label>
          </Row>
        </Col>
      </Row>
    )
  }, [summary])

  useEffect(() => {
    if (state.filterPressCount > 0 && filterPressCount.current < state.filterPressCount) {
      getSummaryFunc()
    } else if (state.filterPressCount === 0) {
      setSummary({
        count: 0,
        value: 0
      })
    }
    filterPressCount.current = state.filterPressCount
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Body>
          {loading ? 'Loading.....' : error ? 'Lỗi!?' :
            <Row>
              {listSumary}
            </Row>
          }
        </Card.Body>
      </Card>
    </>
  );
};

export default _Summary
